import {useTranslation} from '@/translations/i18n'
import {StyledToggleGroupItem, StyledToggleGroupRoot} from './style'
import {AgendaEntity} from '@/features/agenda/types'
import {ObjectKeys} from '@/utilities/helpers'
import {agendaTargetMapToLabel} from '@/features/agenda/utils'

export const AgendaTargetControl = ({
    value,
    onChange
}: {
    value: AgendaEntity
    onChange: (value: AgendaEntity) => void
}) => {
    const {t} = useTranslation()

    return (
        <StyledToggleGroupRoot
            type="single"
            value={value}
            onValueChange={(value: AgendaEntity) => value && onChange(value)}
        >
            {ObjectKeys(agendaTargetMapToLabel).map(targetKey => (
                <StyledToggleGroupItem
                    key={targetKey}
                    value={targetKey}
                    aria-label={t(agendaTargetMapToLabel[targetKey])}
                >
                    {t(agendaTargetMapToLabel[targetKey])}
                </StyledToggleGroupItem>
            ))}
        </StyledToggleGroupRoot>
    )
}
